import type { ReactNode } from "react";

type CardGridProps = {
  children: ReactNode;
  variant?: "default" | "featured";
  as?: "div" | "section";
  ariaLabel?: string;
  ariaLabelledby?: string;
};

export function CardGrid({ children, variant = "default", as = "div", ariaLabel, ariaLabelledby }: CardGridProps) {
  const Component = as;
  const className = variant === "featured" ? "card-grid card-grid-featured" : "card-grid";

  // Prefer aria-labelledby over aria-label when both are provided
  const ariaProps = ariaLabelledby
    ? { "aria-labelledby": ariaLabelledby }
    : ariaLabel
      ? { "aria-label": ariaLabel }
      : {};

  return (
    <Component className={className} {...ariaProps}>
      {children}
    </Component>
  );
}
